<template>
  <v-container class="grey lighten-5">
    <v-row>
      <v-col cols="12" sm="8">
        <v-card style="padding: 16px;">
          <h2>Termine</h2>
          <br/>
          <v-row justify="start" align="center">
            <v-menu
                ref="menuStart"
                v-model="showStartDatePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="date"
                    label="Start"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="date"
                  :active-picker.sync="activeStartDatePicker"
                  max="2222-01-01"
                  min="1950-01-01"
                  @change="saveStart"
              ></v-date-picker>
            </v-menu>
            <v-menu
                ref="timeMenu"
                v-model="showTime"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="time"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="time"
                    label="Startzeit"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                  v-if="showTime"
                  v-model="time"
                  format="24hr"
                  full-width
                  @click:minute="$refs.timeMenu.save(time)"
              ></v-time-picker>
            </v-menu>
          </v-row>
          <v-row justify="start" align="center">
            <v-menu
                ref="menuEnd"
                v-model="showEndDatePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="endDate"
                    label="Enddatum"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="endDate"
                  :active-picker.sync="activeEndDatePicker"
                  max="2222-01-01"
                  min="1950-01-01"
                  @change="saveEnd"
              ></v-date-picker>
            </v-menu>
            <v-menu
                ref="endTimeMenu"
                v-model="showEndTime"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="endTime"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="endTime"
                    label="Endzeit"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                  v-if="showEndTime"
                  v-model="endTime"
                  format="24hr"
                  full-width
                  @click:minute="$refs.endTimeMenu.save(endTime)"
              ></v-time-picker>
            </v-menu>
          </v-row>
          <v-btn class="ma-1" color="info" @click="createTime">
            Termin erstellen
            <template v-slot:loader>
            <span class="custom-loader">
              <v-icon light>mdi-cached</v-icon>
            </span>
            </template>
          </v-btn>
          <br/>
          <v-divider/>
          <br/>
          <v-row align="center" justify="space-between" class="mb-2">
            <h3 class="mb-0">Alle Termine</h3>
            <v-btn
                small
                outlined
                color="indigo"
                @click="togglePastDates"
            >
              <v-icon left small>{{ showPastDates ? 'mdi-calendar-remove-outline' : 'mdi-calendar-search' }}</v-icon>
              {{ showPastDates ? 'Nur aktuelle Schulungen' : 'Vergangene Schulungen anzeigen' }}
            </v-btn>
          </v-row>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">
                  Start
                </th>
                <th class="text-left">
                  Ende
                </th>
                <th class="text-left">
                  Teilnehmeranzahl
                </th>
                <th class="text-left">
                  Details
                </th>
                <th class="text-left">
                  Status
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="(time, index) in times"
                  :key="index"
              >
                <td>{{ time.date | moment("DD.MM.YYYY HH:mm") }}</td>
                <td>{{ time.end | moment("DD.MM.YYYY HH:mm") }}</td>
                <td>{{
                    time.participants.filter(participant => participant.state !== "REJECTED").length
                  }} Teilnehmer
                </td>
                <td><label v-if="time.applicantsWaiting" style="color: red">Unbestätigte
                  Bewerbungen</label></td>
                <td>
                  <v-btn text class="ma-2" color="info" @click.stop="showDetails(time)">Details
                  </v-btn>
                  <v-btn v-if="time.participants.length === 0" text class="ma-2" color="error"
                         @click.stop="deleteTime(time)">Löschen
                  </v-btn>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card style="padding: 16px">
          <h2>Aktualisieren: {{ data.id }}</h2>
          <v-text-field v-model="title" label="Titel"/>
          <v-text-field v-model="location" label="Ort"/>
          <v-text-field v-model="price" label="Preis"/>
          <v-textarea v-model="description" label="Beschreibung"/>
          <v-checkbox v-model="canBorrowBooks" label="Bücherausleih"/>
          <v-checkbox v-model="lastAssessmentDateRequired" label="Letztes Prüfungsdatum angeben"/>
          <v-checkbox v-model="online" label="Online"/>
          <v-dialog v-model="showParticipants" v-if="selectedTime !== null">
            <v-card style="margin-bottom: 24px">
              <v-card-title class="text-h5 grey lighten-2">
                Teilnehmer am {{ selectedTime.date | moment("DD.MM.YYYY HH:mm") }}
              </v-card-title>
              <v-card-actions>
                <v-btn @click.stop="startPlus1Hour()">Startzeit + 1h</v-btn>
                <v-btn @click.stop="startMinus1Hour()">Startzeit - 1h</v-btn>
                <v-btn @click.stop="endPlusOneHour()">Endzeit + 1h</v-btn>
                <v-btn @click.stop="endMinusOneHour()">Endzeit - 1h</v-btn>
              </v-card-actions>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text_left">Bestellnr.</th>
                    <th class="text-left">Vorname</th>
                    <th class="text-left">Nachname</th>
                    <th class="text-left">Geburtstag</th>
                    <th class="text-left">Email</th>
                    <th class="text-left">Tel.</th>
                    <th class="text-left">Invoice</th>
                    <th class="text-left">Rechnungs-E-Mail</th>
                    <th class="text-left">Kommentar</th>
                    <th class="text-left">Anhänge</th>
                    <th class="text-left" v-if="canBorrowBooks">Bücherausleih</th>
                    <th class="text-left" v-if="canBorrowBooks">Bücherausleihadresse</th>
                    <th class="text-left" v-if="lastAssessmentDateRequired">Letzte Prüfung</th>
                    <th class="text-left">Status</th>
                    <th class="text-left">Aktionen</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="(participant, index) in selectedTime.participants" :key="index"
                  >
                    <td>{{ participant.orderId.slice(-5) }}</td>
                    <td>{{ participant.firstName }}</td>
                    <td>{{ participant.lastName }}</td>
                    <td>{{ participant.birthdate  | moment("DD.MM.YYYY") }}</td>
                    <td>{{ participant.email }}</td>
                    <td>{{ participant.invoicePhone }}</td>
                    <td>{{ participant.invoiceAddress }}</td>
                    <td>{{ participant.invoiceDeliveryEmail || "–" }}</td>
                    <td>{{ participant.comment }}</td>
                    <td>
                      <v-tooltip bottom color="primary"
                                 v-for="(attachment, index) in participant.attachments">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs"
                                 v-on="on"
                                 @click="downloadAttachment(attachment)" class="ma-2" outlined
                                 x-small fab
                                 color="indigo">
                            <v-icon>mdi-download</v-icon>
                          </v-btn>

                        </template>
                        <v-btn
                            color="primary"
                            dark
                        >
                          {{ attachment.substring(attachment.indexOf("-") + 1) }}
                        </v-btn>
                      </v-tooltip>


                    </td>
                    <td v-if="canBorrowBooks">{{ participant.wantsToBorrowBooks }}</td>
                    <td v-if="canBorrowBooks">{{ participant.borrowBooksAddress }}</td>
                    <td v-if="lastAssessmentDateRequired">
                      {{ participant.lastAssessmentDate | moment("DD.MM.YYYY") }}
                    </td>
                    <td v-if="participant.state=== 'WAITING'" style="color: blue">
                      <b>{{ participant.state }}</b></td>
                    <td v-else-if="participant.state === 'REJECTED'" style="color: red">
                      <b>{{ participant.state }}</b></td>
                    <td v-else style="color: green"><b>{{ participant.state }}</b></td>
                    <v-btn @click="acceptParticipant(participant)" class="ma-2" outlined x-small fab
                           color="indigo">
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                    <v-btn @click="deleteParticipant(participant)" outlined x-small fab
                           color="red">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-dialog>
          <v-treeview
              item-key="key"
              v-model:selected="tag"
              :items="filterTree"
              selection-type="leaf"
              item-value="name"
              return-object
              selectable
          ></v-treeview>
          <v-card-actions>
            <v-btn class="ma-1" color="info"
                   :disabled="title === '' || description === '' || tag.length !== 1"
                   @click="create">
              Kurs aktualisieren
              <template v-slot:loader>
            <span class="custom-loader">
              <v-icon light>mdi-cached</v-icon>
            </span>
              </template>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar :timeout="5000" :value="success" color="primary" left shaped top app>Gespeichert
    </v-snackbar>

  </v-container>

</template>

<script>

import SuperAdminLiveCourse from "@/components/sites/SuperAdminLiveCourse.vue";
import BuyCourse from "@/models/BuyCourse";
import moment from "moment";
import sharedFilterTree from "@/api/filtertree";

export default {
  name: "SuperAdminCourseApplication",
  components: {SuperAdminLiveCourse},
  props: {
    data: {
      type: BuyCourse
    }
  },

  data: () => ({
    title: "",
    description: "",
    canBorrowBooks: "",
    online: false,
    location: "",
    price: "",
    showStartDatePicker: false,
    showEndDatePicker: false,
    showParticipants: false,
    selectedTime: null,
    activeStartDatePicker: null,
    lastAssessmentDateRequired: false,
    activeEndDatePicker: null,
    agb: "",
    times: [],
    showPastDates: false,
    date: new Date().toISOString().substring(0, 10),
    endDate: new Date().toISOString().substring(0, 10),
    time: "14:00",
    endTime: "16:00",
    showTime: false,
    showEndTime: false,
    tag: [],
    success: null,
    filterTree: sharedFilterTree
  }),
  methods: {
    startPlus1Hour() {
      let start = moment(this.selectedTime.date).add("1", "hours").toISOString();
      let end = this.selectedTime.end;
      this.$httpBuyCourseApi.updateTime(this.data.id, this.selectedTime.id, start,
          end, () => {
            this.loadDates();
            this.selectedTime.date = start;
          });
    },
    endPlusOneHour() {
      let start = this.selectedTime.date;
      let end = moment(this.selectedTime.end).add("1", "hours").toISOString();
      this.$httpBuyCourseApi.updateTime(this.data.id, this.selectedTime.id, start,
          end, () => {
            this.loadDates();
            this.selectedTime.end = end;
          });
    },
    startMinus1Hour() {
      let start = moment(this.selectedTime.date).subtract("1", "hours").toISOString();
      let end = this.selectedTime.end;
      this.$httpBuyCourseApi.updateTime(this.data.id, this.selectedTime.id, start,
          end, () => {
            this.loadDates();
            this.selectedTime.date = start;
          });
    },
    endMinusOneHour() {
      let start = this.selectedTime.date;
      let end = moment(this.selectedTime.end).subtract("1", "hours").toISOString();
      this.$httpBuyCourseApi.updateTime(this.data.id, this.selectedTime.id, start,
          end, () => {
            this.loadDates();
            this.selectedTime.end = end;
          });
    },
    showDetails(timeItem) {
      this.selectedTime = timeItem;
      this.showParticipants = true;
    },
    deleteTime(timeItem) {
      this.$httpBuyCourseApi.deleteTime(this.data.id, timeItem.id, () => {
        this.loadDates();
      });
    },
    createTime() {
      this.$httpBuyCourseApi.createTime(this.data.id, new Date(this.date + " " + this.time),
          new Date(this.endDate + " " + this.endTime), () => {
            this.loadDates();
          });
    },
    saveStart(date) {
      this.$refs.menuStart.save(date)
    },
    saveEnd(date) {
      this.$refs.menuEnd.save(date)
    },
    acceptParticipant(participant) {
      this.$httpBuyCourseApi.acceptApplicant(this.data.id, this.selectedTime.id, participant.id,
          () => {
            this.selectedTime.participants.filter(
                (item) => item.orderId === participant.orderId).forEach(
                (item) => item.state = "ACCEPTED")
          });
    },
    deleteParticipant(participant) {
      this.$httpBuyCourseApi.denyApplicant(this.data.id, this.selectedTime.id, participant.id,
          () => {
            this.selectedTime.participants.filter(
                (item) => item.orderId === participant.orderId).forEach(
                (item) => item.state = "REJECTED")
          });
    },
    create() {
      this.$httpBuyCourseApi.create(new BuyCourse({
        title: this.title,
        description: this.description,
        id: this.data.id,
        online: this.online,
        tagKey: this.tag[0].key,
        price: this.price,
        location: this.location,
        tags: this.tag[0].tags,
        canBorrowBooks: this.canBorrowBooks,
        lastAssessmentDateRequired: this.lastAssessmentDateRequired
      }), () => {
        this.successText = "Erfolgreich aktualisiert"
        this.success = true;
        this.loadData();
        setTimeout(() => {
          this.success = false;
        }, 3000);
      });
    },
    togglePastDates() {
      this.showPastDates = !this.showPastDates;
      this.loadDates();
    },

    loadData() {
      this.$emit("reload");
      this.$httpBuyCourseApi.getTimes(this.data.id, this.showPastDates, (result) => {
        this.times = result;
      })
    },

    loadDates() {
      this.$httpBuyCourseApi.getTimes(this.data.id, this.showPastDates, (result) => {
        this.times = result;
      })
    },
    downloadAttachment(attachment) {
      this.$httpBuyCourseApi.downloadAttachment(attachment, (result) => {
        const blob = new Blob([result.data])
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = attachment;
        link.click()
        URL.revokeObjectURL(link.href)
      })
    }
  },
  mounted() {
    this.title = this.data.title;
    this.description = this.data.description;
    this.online = this.data.online;
    this.canBorrowBooks = this.data.canBorrowBooks;
    this.lastAssessmentDateRequired = this.data.lastAssessmentDateRequired;
    this.location = this.data.location;
    this.price = this.data.price;
    this.tag = [{tags: this.data.tags, key: this.data.tagKey}]
    this.loadDates();
  }
}
</script>

<style scoped>

</style>
